import module from 'module';
import _ from 'lodash';

import './stock-item-transfer-to-head-office.style.less';
import templateUrl from './stock-item-transfer-to-head-office.template.html';

class StockItemTransferToHeadOfficeView {
  constructor($location, $route, command, http, notification, confirmation, branchService, reportService,
              popup, systemPropertyCache, nav, pawnItemCache) {
    this.$location = $location;
    this.$route = $route;
    this.command = command;
    this.http = http;
    this.confirmation = confirmation;
    this.branchService = branchService;
    this.systemPropertyCache = systemPropertyCache;
    this.nav = nav;
    this.pawnItemCache = pawnItemCache;
  }

  async $onInit() {
    await this.setHeadOfficeBranch();
  }

  async setHeadOfficeBranch() {
    const [properties, branches] = await Promise.all([
      this.systemPropertyCache.toPromise(),
      this.branchService.toPromise()
    ]);

    const headOfficeId = _.find(properties, {code: 'HEAD_OFFICE_BRANCH_ID'}).value
    this.branches = branches.filter(b => b.id === Number(headOfficeId))
  }

  async transfer() {
    const confirm = await this.confirmation(`Do you want send item to ${this.branches[0].name}?`);
    if (!confirm) {
      return;
    }

    const request = {
      itemIds: this.itemIds
    };

    const response = await this.command.execute('TransferStockItemsToHeadOffice', request).toPromise();
    if (response.approvalRequired) {
      return;
    }

    this.pawnItemCache.evict();
    this.$location.path(this.cancelUrl);
    this.$route.reload();
  }
}

module.component('stockItemTransferToHeadOfficeView', {
  templateUrl: templateUrl,
  bindings: {
    itemIds: '<',
    cancelUrl: '<'
  },
  controller: StockItemTransferToHeadOfficeView
});
